import { Component, computed, input, output } from '@angular/core';
import { IconName, provideIcons } from '@ng-icons/core';
import {
  lucideColumns2,
  lucideEllipsisVertical,
  lucideLink2,
  lucideLink2Off,
  lucideSquareArrowOutUpRight,
} from '@ng-icons/lucide';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmDropdownMenuImports } from '@spartan-ng/helm/dropdown-menu';
import { HlmIconImports } from '@spartan-ng/helm/icon';
import { hlm } from '@spartan-ng/helm/utils';
import { cva, VariantProps } from 'class-variance-authority';
import { ClassValue } from 'clsx';

import { Certification } from '../../../croisement-référentiel/models/certification';
import { CroisementÉtat } from '../../../croisement-référentiel/models/croisement-état';

const cardVariants = cva('p-xs gap-xs shadow-bottom grid rounded-lg', {
  variants: {
    etat: {
      [CroisementÉtat.A_FAIRE]: ['bg-feedback-warning-lightest text-feedback-warning-main'],
      [CroisementÉtat.EN_COURS]: ['bg-feedback-informative-lightest text-feedback-informative-main'],
      [CroisementÉtat.TERMINE]: ['bg-feedback-positive-lightest text-feedback-positive-main'],
    },
  },
});

export type CardVariants = VariantProps<typeof cardVariants>;

export interface ListActions {
  icon: IconName;
  label: string;
  execute: (certification: Certification) => void;
}

@Component({
  selector: 'app-card-certification',
  imports: [HlmButtonImports, HlmIconImports, HlmDropdownMenuImports],
  templateUrl: './card-certification.component.html',
  providers: [
    provideIcons({ lucideEllipsisVertical, lucideColumns2, lucideLink2, lucideLink2Off, lucideSquareArrowOutUpRight }),
  ],
})
export class CardCertificationComponent {
  readonly certification = input.required<Certification>();
  readonly actions = input<ListActions[]>([]);
  public readonly userClass = input<ClassValue>('', { alias: 'class' });

  public onClick = output<void>();

  protected readonly _computedClass = computed(() =>
    hlm(cardVariants({ etat: this.certification().etatCroisement }), this.userClass()),
  );

  protected readonly _computedState = computed(() => {
    switch (this.certification().etatCroisement) {
      case CroisementÉtat.A_FAIRE:
        return 'Croisement à faire';
      case CroisementÉtat.EN_COURS:
        return 'Croisement en cours';
      case CroisementÉtat.TERMINE:
        return 'Croisement complété';
    }
  });

  protected clickCard() {
    this.onClick.emit();
  }
}
